<script setup>
  const props = defineProps({
    larger: {
      type: Boolean,
      required: false,
      default: false,
    },
    large: {
      type: Boolean,
      required: false,
      default: false,
    },
    type: {
      type: String,
      required: false,
      default: 'span',
    },
    gray: {
      type: Boolean,
      default: false,
    },
  });
</script>
<template>
  <component :is="props.type" :class="{'section-title--gray': gray, large, larger}" class="section-title">
    <slot />
    <slot name="icon" />
  </component>
</template>
<style lang="scss" scoped>
  .section-title {
    position: relative;
    font-weight: var(--font-weight-700);
    display: inline-block;
    z-index: 1;
    font-size: 2rem;
    line-height: 1.5;
    width: fit-content;

    :deep(svg) {
      font-size: 1.5rem;
      margin-left: 1rem;
    }

    &::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 5px;
      background-color: var(--primary-color);
    }
  }

  @media (max-width: 992px) {
    .section-title {
      font-size: 1rem;
      line-height: 1.5;

      :deep(svg) {
        font-size: 1rem;
        margin-left: 0.875rem;
      }

      &::after {
        height: 2px;
        margin-top: 0.25rem;
      }
    }
  }
</style>
